(function () {
  function initJojoListingSpecs(root) {
    if (!root || root.dataset.jojoSpecsReady === 'true') return;
    root.dataset.jojoSpecsReady = 'true';

    var tabs = root.querySelectorAll('[data-jojo-specs-tab]');
    var panels = root.querySelectorAll('[data-jojo-specs-panel]');
    var moreBtn = root.querySelector('[data-jojo-specs-more]');

    function hasCollapsible(panel) {
      return !!(panel && panel.querySelector('.jojo-listing-specs__category--collapsible'));
    }

    function syncMoreButton() {
      if (!moreBtn) return;
      var activePanel = root.querySelector('.jojo-listing-specs__panel.is-active');
      var show = hasCollapsible(activePanel) && !root.classList.contains('is-expanded');
      moreBtn.hidden = !show;
    }

    function activateTab(tabKey) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-jojo-specs-tab') === tabKey;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-jojo-specs-panel') === tabKey;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      root.classList.remove('is-expanded');
      syncMoreButton();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-jojo-specs-tab'));
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        root.classList.add('is-expanded');
        syncMoreButton();
      });
    }

    var defaultTab = root.getAttribute('data-default-tab') || 'tab_1';
    activateTab(defaultTab);
    initStoresDialog(root);
  }

  function initStoresDialog(root) {
    var dialog = root.querySelector('[data-jojo-specs-stores-dialog]');
    var openers = root.querySelectorAll('[data-jojo-specs-stores-open]');
    if (!dialog || !openers.length) return;

    var track = dialog.querySelector('[data-jojo-specs-stores-track]');
    var prev = dialog.querySelector('[data-jojo-specs-stores-prev]');
    var next = dialog.querySelector('[data-jojo-specs-stores-next]');
    var viewport = dialog.querySelector('.jojo-listing-specs__dialog-viewport');
    var index = 0;
    var opener = null;
    var startX = 0;

    function mobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function show(nextIndex) {
      var steps = track ? track.children : [];
      var count = steps.length;
      if (!count) return;
      index = Math.max(0, Math.min(nextIndex, count - 1));
      if (track) {
        track.style.transform = mobile() ? 'translateX(' + -index * 100 + '%)' : '';
      }
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
    }

    function onKey(event) {
      if (event.key === 'Escape') close();
    }

    function open(trigger) {
      opener = trigger || null;
      show(0);
      dialog.hidden = false;
      dialog.classList.add('is-open');
      document.documentElement.classList.add('jojo-listing-specs-lock');
      document.addEventListener('keydown', onKey);
      var closeButton = dialog.querySelector('.jojo-listing-specs__dialog-close');
      if (closeButton) closeButton.focus();
    }

    function close() {
      if (dialog.hidden) return;
      dialog.classList.remove('is-open');
      dialog.hidden = true;
      document.documentElement.classList.remove('jojo-listing-specs-lock');
      document.removeEventListener('keydown', onKey);
      if (opener && opener.focus) opener.focus();
    }

    root._jojoSpecsStoresClose = close;

    openers.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        open(button);
      });
    });

    dialog.querySelectorAll('[data-jojo-specs-stores-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });

    if (prev) {
      prev.addEventListener('click', function () {
        if (prev.disabled) return;
        show(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (next.disabled) return;
        show(index + 1);
      });
    }

    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        function (event) {
          if (!event.changedTouches.length) return;
          startX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchend',
        function (event) {
          if (!mobile() || !event.changedTouches.length) return;
          var delta = event.changedTouches[0].clientX - startX;
          if (Math.abs(delta) < 40) return;
          if (delta < 0 && next && !next.disabled) show(index + 1);
          if (delta > 0 && prev && !prev.disabled) show(index - 1);
        },
        { passive: true }
      );
    }

    var mq = window.matchMedia('(max-width: 749px)');
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        if (dialog.hidden) return;
        show(index);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-jojo-listing-specs]').forEach(initJojoListingSpecs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-jojo-listing-specs]');
    if (root) {
      root.dataset.jojoSpecsReady = 'false';
      initJojoListingSpecs(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var root = event.target.querySelector('[data-jojo-listing-specs]');
    if (root && root._jojoSpecsStoresClose) root._jojoSpecsStoresClose();
  });
})();
